import { render, staticRenderFns } from "./BesoinsSanteSenior.vue?vue&type=template&id=bb93d57e&scoped=true&"
import script from "./BesoinsSanteSenior.vue?vue&type=script&lang=js&"
export * from "./BesoinsSanteSenior.vue?vue&type=script&lang=js&"
import style1 from "./BesoinsSanteSenior.vue?vue&type=style&index=1&id=bb93d57e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb93d57e",
  null
  
)

export default component.exports